// Logout the user from the platform
export const logoutUser = (platformId: string | null | undefined) => {
  localStorage.clear();
  const current_location = window.location.origin + '/main/callback';
  // Redirect to FusionAuth logout
  window.location.href = `${
    process.env['NX_FUSIONAUTH_URL'] || 'UNSET_NX_FUSIONAUTH_URL'
  }/oauth2/logout?post_logout_redirect_uri=${current_location}&client_id=${platformId}`;
};
